import { z } from 'zod';
import { aiPromptKindSchema } from '../ai-step-outputs.js';

/**
 * AiFieldStatsRow — matches the `ai_field_stats` DB table.
 * PK: (kind, field, mode)
 * mode='default' for categories scenarios; 'text'|'vision' for generate_wallpapers.
 */
export const aiFieldStatsRowSchema = z.object({
  kind:           aiPromptKindSchema,
  field:          z.string(),
  mode:           z.string(),
  samples:        z.number().int().nonnegative(),
  // avg_tokens_out is the single learned content-size signal for a field.
  avg_tokens_out: z.number().nonnegative(),
  updated_at:     z.string().datetime(),
});

export type AiFieldStatsRow = z.infer<typeof aiFieldStatsRowSchema>;

/**
 * PerFieldTokens — per-field token attribution block emitted on `bulk_ai.batch.done`
 * payload and used by the stats-updater handler.
 *
 * `tokensIn` has been retired (idea 2026-06-24-wandero-bulk-ai-fielddef-collapse-contenttokens).
 * Zod strips unknown keys by default, so in-flight events carrying the old `tokensIn`
 * field still parse correctly — the extra key is silently ignored.
 */
export const perFieldTokensSchema = z.object({
  field:     z.string(),
  tokensOut: z.number().nonnegative(),
  samples:   z.number().int().nonnegative(),
});

export type PerFieldTokens = z.infer<typeof perFieldTokensSchema>;
